// 客户
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("client") || ""
}

const getters = {
  getClient:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("client",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("client")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}